import classNames from 'classnames';
import React, {ReactElement} from 'react';

import Row from '../../common/Row';
import {useLayoutContext} from './Layout';

type Props = {
  entries: {id: string; url: string; text: string}[];
  active: string;
};

const SubNav = ({entries, active}: Props): ReactElement => {
  const layoutContext = useLayoutContext();

  return (
    <Row
      className={classNames(
        'p-xs gap-lg bg-primary-600 justify-center text-sm',
        'mobile:sticky mobile:bg-opacity-95 mobile:z-10'
      )}
      style={{top: layoutContext.navBarHeight || undefined}}
    >
      {entries.map(({id, url, text}) => (
        <a key={id} href={url} className={classNames('!text-white', active === id && 'font-semibold')}>
          {text}
        </a>
      ))}
    </Row>
  );
};

export default SubNav;
